import { render, staticRenderFns } from "./FormFieldRadioButtons.vue?vue&type=template&id=48f15674&"
import script from "./FormFieldRadioButtons.vue?vue&type=script&lang=js&"
export * from "./FormFieldRadioButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports